import { PermissionsPlugin } from '@absis/core-plugins';
import {
  PermissionsOptions,
  PermissionResult,
} from '@absis/core-plugins/dist/types/types/core-plugins-types';

export const CBPermissions: PermissionsPlugin = {
  query(options: PermissionsOptions): Promise<PermissionResult> {
    return navigator.permissions.query(options as PermissionDescriptor);
  },
};
